// Investiture
import React from 'react';
import JeeResults2026 from '../views/JeeResults2026';

const InvestiturePage = () => { return <JeeResults2026 />;};

export default InvestiturePage;
